module.exports = __webpack_public_path__ + "img/nanhaishenmiao.883f31c1.png";